<template>
  <v-dialog :model-value="modelValue" max-width="500">
    <v-card class="d-flex flex-column px-4 pb-2">
      <v-sheet class="text-h6 py-2 mb-2 d-flex align-center">
        Διαχείριση αντικατάστασης λέξεων
        <v-spacer />
        <v-btn
          variant="plain"
          size="x-small"
          icon="mdi-close"
          @click="$emit('update:modelValue', false)"
        />
      </v-sheet>
      <v-sheet class="d-flex flex-column gap-4 mb-2">
        <div class="text-body-2">Λέξη εισόδου</div>
        <v-text-field
          v-model="inputWord"
          class="mb-4"
          variant="outlined"
          density="compact"
          hide-details
          :error-messages="inputWordError"
          @input="validateInputWord"
        />
        <div class="text-body-2">Λέξη αντικατάστασης</div>
        <v-text-field
          v-model="replacementWord"
          class="mb-4"
          variant="outlined"
          density="compact"
          hide-details
          :error-messages="replacementWordError"
          @input="validateReplacementWord"
        />
        <div class="text-body-2 mt-1" style="color: #444">
          Επιτρέπονται μόνο οι αλφαριθμητικοί χαρακτήρες και τα σύμβολα * και -.<br />
          Η λέξη εισόδου πρέπει να είναι τουλάχιστον 3 χαρακτήρες.
        </div>
      </v-sheet>
      <div class="d-flex justify-end mt-2">
        <v-btn
          size="small"
          color="grey-lighten-2"
          height="28"
          class="ml-2 px-3 text-capitalize"
          @click="$emit('update:modelValue', false)"
        >
          Άκυρο
        </v-btn>
        <v-btn
          size="small"
          height="28"
          color="grey-lighten-2"
          class="ml-2 px-3 text-capitalize"
          :class="{ 'opacity-40': !isValid }"
          :disabled="!isValid"
          @click="saveWordReplacement"
        >
          OK
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { addWordReplacement, getWordReplacements } from '@/utils/wordReplacements.interface'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'resetWords'])

const inputWord = ref('')
const replacementWord = ref('')
const inputWordError = ref('')
const replacementWordError = ref('')

const allowedPattern = /^[A-Za-zΑ-Ωα-ω0-9*-]+$/

const isValid = computed(() => {
  return (
    inputWord.value && replacementWord.value && !inputWordError.value && !replacementWordError.value
  )
})

const validateInputWord = () => {
  if (!inputWord.value || inputWord.value.length < 3) {
    inputWordError.value = 'Η λέξη εισόδου πρέπει να είναι τουλάχιστον 3 χαρακτήρες'
  } else if (!allowedPattern.test(inputWord.value)) {
    inputWordError.value = 'Επιτρέπονται μόνο αλφαριθμητικοί χαρακτήρες και τα σύμβολα * και -'
  } else {
    const existingReplacements = getWordReplacements()
    if (existingReplacements.some((r) => r.inputWord === inputWord.value)) {
      inputWordError.value = 'Η λέξη εισόδου υπάρχει ήδη'
    } else {
      inputWordError.value = ''
    }
  }
}

const validateReplacementWord = () => {
  if (!replacementWord.value || replacementWord.value.length < 3) {
    replacementWordError.value = 'Η λέξη αντικατάστασης πρέπει να είναι τουλάχιστον 3 χαρακτήρες'
  } else if (!allowedPattern.test(replacementWord.value)) {
    replacementWordError.value =
      'Επιτρέπονται μόνο αλφαριθμητικοί χαρακτήρες και τα σύμβολα * και -'
  } else if (replacementWord.value === inputWord.value) {
    replacementWordError.value = 'Η λέξη αντικατάστασης δεν μπορεί να είναι ίδια με τη λέξη εισόδου'
  } else {
    replacementWordError.value = ''
  }
}

const saveWordReplacement = () => {
  if (isValid.value) {
    addWordReplacement(inputWord.value, replacementWord.value)
    emit('resetWords')
    inputWord.value = ''
    replacementWord.value = ''
    inputWordError.value = ''
    replacementWordError.value = ''
    emit('update:modelValue', false)
  }
}
</script>
